$(document).on('page-init-complete',
    function () {
        //Case insensitive contains
        jQuery.expr[':'].icontains = function (a, i, m) {
            return jQuery(a).text().toUpperCase()
                .indexOf(m[3].toUpperCase()) >= 0;
        };
    });



